import React from "react";
import { useErrorBoundary } from "react-error-boundary";
import { isNil } from "ramda";

import { ButtonVariants, NavigateButton } from "affinityUI/elements/button";
import { ButtonGroup } from "affinityUI/form/components";
import { Layout } from "affinityUI/structures/layout";
import { Users } from "components/views/users";
import { useGetUsersQuery } from "gql";
import { Restricted } from "lib/auth";

export const UsersPage: React.FC = () => {
  const { showBoundary: onError } = useErrorBoundary();
  const { data, loading: usersLoading } = useGetUsersQuery({ onError });
  const users = data?.users;

  return (
    <Layout
      title="Users"
      loading={usersLoading}
      actions={
        <ButtonGroup>
          <Restricted permits={["change_role"]}>
            <NavigateButton id="edit_roles" variant={ButtonVariants.SECONDARY} to="/settings/roles">
              Edit roles
            </NavigateButton>
          </Restricted>
          <Restricted permits={["add_user"]}>
            <NavigateButton id="add_user" to="add">
              Add user
            </NavigateButton>
          </Restricted>
        </ButtonGroup>
      }
    >
      {!isNil(users) && <Users users={users} />}
    </Layout>
  );
};
